import { render, staticRenderFns } from "./DownloadDocumentsModal.vue?vue&type=template&id=1d06e400&scoped=true&"
import script from "./DownloadDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./DownloadDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./DownloadDocumentsModal.vue?vue&type=style&index=0&id=1d06e400&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d06e400",
  null
  
)

export default component.exports